var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"jsp-icon",class:_vm.size,style:(_vm.style)},[(_vm.svg)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.svg)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }